import { capitalize } from "@/utils/capitalize";
import { translateFunc } from "@/utils/translateFunc";
import { ProcessingState } from "./useAction";

export const useButtonLabel = (processingState: ProcessingState, isProcessing: boolean) => {
    const getButtonLabel = (): string => {
        if (!isProcessing) return capitalize(translateFunc("enlarge-image"));
        if (processingState.state === "loading_image") return translateFunc("preparing");
        if (processingState.state === "image_loaded") return translateFunc("preparing");
        if (processingState.state === "creating_import_task") return translateFunc("uploading");
        if (processingState.state === "uploading")
            return `${translateFunc("uploading")}(${processingState.progress} %)`;
        if (processingState.state === "creating_job") return translateFunc("processing");
        if (processingState.state === "processing_job") return translateFunc("processing");
        if (processingState.state === "job_succeeded") return translateFunc("complete");
        return translateFunc("please_wait");
    };

  return {getButtonLabel}
}
